const funding_ranges = [
  { id: 0, key: 'bootstrapped', label: 'None/Bootstrapped' },
  { id: 1, key: '0_100k', label: '$0 to $100k' },
  { id: 2, key: '100k_250k', label: '$100k to $250k' },
  { id: 3, key: '250k_500k', label: '$250k to $500k' },
  { id: 4, key: '500k_1m', label: '$500k to $1M' },
  { id: 5, key: '1m_5m', label: '$1m to $5m' },
  { id: 6, key: '5m_10m', label: '$5m to $10m' },
  { id: 7, key: '10_25m', label: '$10m to $25m' },
  { id: 8, key: '25m_more', label: 'Over $25m' },
  { id: 9, key: 'undisclosed', label: 'Undisclosed' },
]
export default funding_ranges
